<template>
  <aside
    v-show="seasons.length"
    class="c-seasons-sidebar u-color-primary"
  >
    <div class="c-seasons-sidebar__season-wrapper">
      <div
        v-accessibility-focus="toggle"
        :aria-disabled="seasons.length <= 1"
      >
        <h3 class="o-typography__headline3">
          <template v-if="show">
            {{ $t('glossary.seasons') }}
          </template>
          <template v-else>
            {{ $t('glossary.season') }}
            {{ currentSeason.number }}
          </template>
          <i
            v-if="seasons.length > 1"
            class="o-icon o-icon--align-middle o-icon--chev-right u-color-accent c-seasons-sidebar__dropdown-arrow"
            :class="{ 'is-open': show }"
          ></i>
        </h3>
      </div>
      <div
        v-show="show"
        v-accessibility-focus="toggle"
        :tabindex="show ? TabIndex.DISABLED : TabIndex.ENABLED"
        class="c-seasons-sidebar__season-list"
      >
        <v-styled-scroll ref="seasons">
          <ul>
            <li
              v-for="season in seasons"
              :key="season.id"
              v-accessibility-focus="() => changeSeason(season)"
            >
              <h3 class="o-typography__headline3">
                {{ $t('glossary.season') }} {{ season.display }}
              </h3>
            </li>
          </ul>
        </v-styled-scroll>
      </div>
    </div>
    <div class="c-seasons-sidebar__episodes">
      <div>
        <v-styled-scroll ref="scroll-wrapper">
          <ul v-if="episodes.length">
            <li
              v-for="episode in episodes"
              :key="episode.id"
              :class="{ 'is-active': product.id === episode.id }"
            >
              <ui-player-seasons-episode :episode="episode"></ui-player-seasons-episode>
            </li>
          </ul>
        </v-styled-scroll>
      </div>
    </div>
  </aside>
</template>
<script>
  import { Episodes, Seasons } from '@/shared/libs/sdk';
  import { state, toggleSeasons } from '@/shared/components/player/store';
  import UiPlayerSeasonsEpisode
    from '@/shared/components/player/components/overlay/components/seasons/components/episode/index.vue';
  import { VStyledScroll } from '@/shared/components';
  import { NavigationContextManager } from '@/shared/utils/accessibility';
  import { TabIndex } from '@/shared/enums';

  export default {
    name: 'UiPlayerSeasons',
    components: {
      VStyledScroll,
      UiPlayerSeasonsEpisode,
    },
    enums: {
      TabIndex,
    },
    data() {
      return {
        episodes: [],
        seasons: [],
        show: false,
        currentSeason: {},
      };
    },
    computed: {
      product() {
        return state.product;
      },
    },
    watch: {
      currentSeason(season) {
        if (season.id) {
          this.getEpisodesFromSeason()
            .then(() => NavigationContextManager.updateContext());
        }
      },
    },
    created() {
      const serialId = state.product.season.serial.id;
      const seasons = new Seasons({ id: serialId });
      seasons
        .fetchAll()
        .then(() => {
          this.seasons = seasons.collection.records
            .map((season) => ({
              ...season,
              serial: {
                id: serialId,
              },
            }));
          this.currentSeason = state.product.season;
        });
    },
    mounted() {
      NavigationContextManager.pushContext(this.$el, toggleSeasons, { savePrevFocus: true });
    },
    beforeDestroy() {
      NavigationContextManager.popContext();
    },
    methods: {
      toggle() {
        if (this.seasons.length === 1) {
          return;
        }

        this.show = !this.show;
        this.$nextTick(() => {
          this.$refs.seasons
            .perfectScroll
            .update();
        });
      },
      getEpisodesFromSeason() {
        const episodes = new Episodes();
        episodes.season = this.currentSeason;
        return episodes
          .fetchAll('', {
            serialId: state.product.id,
            seasonId: this.currentSeason.id,
            reset: true,
          })
          .then(() => {
            this.episodes = episodes.collection.records;
            return this.$nextTick();
          })
          .then(() => {
            this.$refs['scroll-wrapper']
              .perfectScroll
              .update();
          });
      },
      changeSeason(season) {
        this.currentSeason = season;
      },
    },
  };
</script>
